import React, { createContext } from "react";

import type { Phase, FlowMode } from "../types";

import type { ScoreData, BriefData } from "../services/api";

export interface ModalConfig {
  isOpen: boolean;
  title: string;
  message: string;
  showProgress: boolean;
  type?: "alert" | "confirm";
  onConfirm?: () => void;
}

export interface ConsultationContextType {
  // Data State
  scoreData: ScoreData | null;
  setScoreData: (data: ScoreData | null) => void;
  briefData: BriefData | null;
  setBriefData: (data: BriefData | null) => void;
  flowMode: FlowMode;
  setFlowMode: (mode: FlowMode) => void;
  briefingDone: boolean;
  setBriefingDone: (done: boolean) => void;

  // UI State
  phase: Phase;
  setPhase: (phase: Phase) => void;
  isThinking: boolean;
  setIsThinking: (thinking: boolean) => void;
  modalConfig: ModalConfig;
  setModalConfig: React.Dispatch<React.SetStateAction<ModalConfig>>;

  // Refs
  mouthRef: React.RefObject<HTMLDivElement | null>;
}

export const ConsultationContext = createContext<
  ConsultationContextType | undefined
>(undefined);
